import FrameForgetImg from '@/assets/images/pin-code.png'
import Notice from '@/components/common/Notice'
import CustomModal from '@/components/ui/ui-react-antd/Modal/CustomModal'
import Button from '@/components/ui/ui-react-antd/MyButton/Button'
import AuthService from '@/shared/services/AuthService'
import { getRegexEmail } from '@/shared/utils/stringsUtils'
import { ArrowLeftOutlined, CloseOutlined, MailOutlined } from '@ant-design/icons'
import { Form, Input, Typography } from 'antd'
import { useState } from 'react'
import styled from 'styled-components'

const StyledModal = styled(CustomModal)`
  /* Dùng && để nhân đôi độ ưu tiên, đánh bại file style.scss của dự án */
  && .ant-modal-container {
    padding: 0 !important;
  }
  
  && .ant-modal-content {
    padding: 0 !important;
    border-radius: 16px !important;
    overflow: hidden !important;
  }

  && .ant-modal-body {
    padding: 0 !important;
  }
`

const ForgetModal = ({
  openForgetPassModal,
  handleCancel,
  handleLogin,
  setOpenVerifyModal,
  setEmail,
}: any) => {
  const [loading, setLoading] = useState(false)
  const [form] = Form.useForm()

  const sendOTP = async () => {
    try {
      setLoading(true)
      const values = await form.validateFields()
      setEmail(values.email)
      const res = await AuthService.sendOtp(values)

      if (res && res.isOk === true) {
        Notice({
          isSuccess: true,
          msg: 'Mã xác minh đã được gửi đến email của bạn!',
        })
        setOpenVerifyModal(true)
      }
    } catch (error: any) {
      console.error('Error in sendOTP catch block:', error)
      // Bỏ qua nếu là lỗi validate form (hiển thị inline)
      if (error?.errorFields) return
      // Bỏ qua nếu là lỗi API đã được Axios Interceptor xử lý (có toast.error)
      if (error?.errorCode || error?.errorMessage || error?.response) return

      Notice({
        isSuccess: false,
        msg: 'Có lỗi xảy ra khi gửi OTP. Vui lòng thử lại.',
      })
    } finally {
      setLoading(false)
    }
  }

  const handleBackToLogin = () => {
    handleCancel()
    handleLogin()
  }

  return (
    <StyledModal
      title={null}
      width="450px"
      footer={null}
      closable={false}
      open={openForgetPassModal}
      onCancel={handleCancel}
    >
      <div
        style={{
          background: 'linear-gradient(180deg, #d3eafc 0%, #ffffff 40%)',
          padding: '32px 24px 24px 24px',
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          borderRadius: '10px',
        }}
      >
        <div
          onClick={handleCancel}
          style={{
            position: 'absolute',
            top: '16px',
            right: '16px',
            width: '32px',
            height: '32px',
            borderRadius: '50%',
            backgroundColor: 'rgba(255, 255, 255, 0.6)',
            boxShadow: '0 2px 8px rgba(0,0,0,0.1)',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            cursor: 'pointer',
            zIndex: 10,
          }}
        >
          <CloseOutlined style={{ color: '#555', fontSize: '14px' }} />
        </div>

        <div style={{ textAlign: 'center', marginBottom: '24px', marginTop: '10px' }}>
          <img
            src={FrameForgetImg}
            alt="Forget Password"
            style={{ width: '80px', display: 'block', margin: '0 auto 16px auto' }}
          />
          <Typography.Title level={3} style={{ margin: 0, fontWeight: 700, color: '#111' }}>
            Quên Mật Khẩu
          </Typography.Title>
          <Typography.Text
            style={{
              color: '#666',
              display: 'block',
              marginTop: '8px',
              padding: '0 10px',
              fontSize: '14px',
            }}
          >
            Vui lòng nhập địa chỉ email liên kết với tài khoản của bạn để nhận hướng dẫn khôi phục
            mật khẩu.
          </Typography.Text>
        </div>

        <Form form={form} layout="vertical">
          <Form.Item
            rules={[
              {
                required: true,
                message: 'Bạn chưa nhập địa chỉ email!',
              },
              {
                pattern: getRegexEmail(),
                message: 'Email nhập sai định dạng!',
              },
            ]}
            label={<span style={{ fontWeight: 600, fontSize: '14px', color: '#111' }}>Email</span>}
            name="email"
            style={{ marginBottom: '24px' }}
          >
            <Input
              prefix={
                <MailOutlined style={{ color: '#bfbfbf', marginRight: '8px', fontSize: '18px' }} />
              }
              placeholder="Nhập email của bạn"
              size="large"
              style={{
                height: '48px',
                borderRadius: '8px',
                fontSize: '15px',
              }}
            />
          </Form.Item>
        </Form>

        <div
          style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginTop: '8px',
          }}
        >
          <Button
            type="text"
            onClick={handleBackToLogin}
            style={{
              padding: 0,
              fontSize: '15px',
              color: '#000',
              fontWeight: 500,
              backgroundColor: 'transparent',
              border: 'none',
              boxShadow: 'none',
            }}
            icon={<ArrowLeftOutlined />}
          >
            Quay lại
          </Button>

          <Button
            loading={loading}
            className="btn-w100 btn-hover-shadow"
            type="primary"
            htmlType="submit"
            onClick={() => {
              sendOTP()
            }}
            style={{
              width: '160px',
              height: '44px',
              borderRadius: '8px',
              fontSize: '15px',
              fontWeight: '500',
            }}
          >
            Xác nhận
          </Button>
        </div>
      </div>
    </StyledModal>
  )
}

export default ForgetModal
